import React from 'react';

export const selectedContext = React.createContext("");
